<br>
<div>
  <button type='button' class="btn ms-2 btn-default" (click)="startConsolidation(false)" *ngIf="!isRunningConsolidation">Start Consolidation</button>
</div>
<br>
<div *ngIf="isRunningConsolidation">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Starting consolidation...</span>
  </div>
  <label>Starting consolidation...</label>
</div>
<Label class="ms-3">{{labelText}}</Label>
